import {
  arrow,
  flip,
  offset,
  shift,
  size,
  type Middleware,
} from "@floating-ui/react";
import { TOOLTIP_OFFSET, TOOLTIP_SIDES_OFFSET } from "./constants";
import { FloatingMiddlewaresOptions } from "./types";

export const getFloatingMiddlewares = ({
  arrowElement,
}: FloatingMiddlewaresOptions): Middleware[] => [
  offset(TOOLTIP_OFFSET),
  flip(),
  shift({ padding: TOOLTIP_OFFSET }),
  size({
    apply(applyParams) {
      Object.assign(applyParams.elements.floating.style, {
        maxWidth: `${applyParams.availableWidth - TOOLTIP_SIDES_OFFSET}px`,
        maxHeight: `${applyParams.availableHeight - TOOLTIP_SIDES_OFFSET}px`,
      });
    },
  }),
  arrow({ element: arrowElement }),
];
